import React, { useState, useEffect } from "react";
import * as S from "./styles";
import * as GS from "../../utils/globalStyles/background";
import { useUserContext } from "../../contexts/user/userContext";
import Transfer from "../transfer";
import Statement from "../statement";
import ModalTransfer from "../modalTransfer";
import api from "../../utils/services/database";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { getInfoForUser } from "../../utils/services/modules/wallet";
import { ITransactionItem } from "../../utils/services/modules/transactions";
import ModalReceipt, { IReceiptData } from "../modalReceipt"; // Ajuste o caminho se necessário

const Wallet: React.FC = () => {
  const { state: userState, dispatch: userDispatch } = useUserContext();
  const [showReceipt, setShowReceipt] = useState(false);
  const [receiptData, setReceiptData] = useState<IReceiptData | null>(null);
  const [showTransfer, setShowTransfer] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [valueTransfer, setValueTransfer] = useState<string>("");
  const [codeSend, setCodeSend] = useState<string>("");
  const [handleButton, setHandleButton] = useState<boolean>(true);
  const [infoUserTransfer, setInfoUserTransfer] = useState({
    infoTransfer: { name: "", avatar: "", code: 0 },
  });

  // Abre o comprovante de uma transferência enviada a partir do Extrato
  const handleOpenReceipt = (transaction: ITransactionItem) => {
    setReceiptData({
      nameReceiver: transaction.name,
      codeReceiver: transaction.code,
      amount: transaction.amount,
      date: transaction.date,
      nameSender: userState.user?.name,
    });
    setShowReceipt(true);
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get("code");
  const [loading, setLoading] = useState<boolean>(false);

  const ensureMinimumLoadingTime = async (
    promise: Promise<any>,
    minTime: number,
  ) => {
    const start = Date.now();
    const result = await promise; // Aguarda a requisição ser resolvida
    const elapsed = Date.now() - start;
    const remainingTime = minTime - elapsed;
    if (remainingTime > 0) {
      await new Promise((resolve) => setTimeout(resolve, remainingTime)); // Garante o tempo mínimo
    }
    return result;
  };

  useEffect(() => {
    if (code) {
      setCodeSend(code);
    }
  }, [code]);

  const clearInputs = () => {
    setValueTransfer("");
    setCodeSend("");
  };

  const serializerNumber = (value: number) => {
    return value.toLocaleString("pt-BR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  const handleOpenModal = async () => {
    /* if() */
    try {
      const data = await getInfoForUser(codeSend, userState.user?.token!);
      setInfoUserTransfer(data);
      setShowModal(true);
    } catch (error) {
      console.error("Erro na requisição:", error);
      clearInputs();
      toast.error("Code invalido!", {
        position: "top-right",
        autoClose: 3000, // Fecha automaticamente após 3 segundos
      });
      setShowModal(false);
    }
  };

  const handleTransfer = async () => {
    setLoading(true); // Ativa o loading antes de iniciar a requisição

    await ensureMinimumLoadingTime(
      (async () => {
        try {
          setShowModal(false);
          const response = await api.patch(
            "/transactions/transfer-coins",
            {
              code: parseInt(codeSend, 10),
              coinsValue: parseInt(valueTransfer, 10),
            },
            {
              headers: {
                "x-access-token": userState.user?.token,
              },
            },
          );

          clearInputs();
          toast.success("Transação concluida com sucesso!", {
            position: "top-right",
            autoClose: 3000, // Fecha automaticamente após 3 segundos
          });
          // O Extrato recarrega sozinho quando a aba é aberta
          userDispatch({
            type: "UPDATE_COINS",
            payload: { coins: response.data.coins },
          });
          setReceiptData({
            nameReceiver: response.data.name,
            codeReceiver: response.data.code,
            amount: response.data.amount,
            date: response.data.date, // 🎯 AQUI ESTÁ A MÁGICA: Pegando a data real do banco de dados
            nameSender: userState.user?.name,
          });
          setShowReceipt(true);
          setLoading(false);
        } catch (error: any) {
          setShowModal(false);
          toast.error("Transação não concluida!", {
            position: "top-right",
            autoClose: 3000, // Fecha automaticamente após 3 segundos
          });
          console.error("Erro na transferência:", error?.response?.data?.error);
          setLoading(false);
        }
      })(),
      3000, // Tempo mínimo de 3 segundos
    );
  };

  return (
    <S.Container>
      <S.BalanceCard>
        <S.Balance>Saldo Disponível</S.Balance>
        <S.BalanceValue>
          {userState.user?.coins ? serializerNumber(userState.user.coins) : "0"}
          <S.TransferIcon />
        </S.BalanceValue>
      </S.BalanceCard>

      <S.TabContainer>
        <S.TabButton
          active={showTransfer}
          onClick={() => setShowTransfer(true)}
        >
          Transferir
        </S.TabButton>
        <S.TabButton
          active={!showTransfer}
          onClick={() => setShowTransfer(false)}
        >
          Extrato
        </S.TabButton>
      </S.TabContainer>

      <S.InfoContainer>
        {showTransfer ? (
          <Transfer
            codeSend={codeSend}
            setCodeSend={setCodeSend}
            setValueTransfer={setValueTransfer}
            valueTransfer={valueTransfer}
            setShowModal={handleOpenModal} /* Aqui usamos a função correta */
            handleButton={handleButton}
            setHandleButton={setHandleButton}
            codeUser={userState.user?.code || 0}
            sald={userState.user?.coins || 0}
          />
        ) : (
          <Statement
            token={userState.user?.token}
            onOpenReceipt={handleOpenReceipt}
          />
        )}
      </S.InfoContainer>

      <ModalTransfer
        handleTransfer={handleTransfer}
        valueTransfer={valueTransfer}
        open={showModal}
        onClose={() => setShowModal(false)}
        infoUserTransfer={infoUserTransfer}
      />

      <GS.BackdropMui open={loading} style={{ zIndex: 1300, color: "#fff" }}>
        <GS.CircularProgressMui color="inherit" size={80} />
      </GS.BackdropMui>
      <ModalReceipt
        open={showReceipt}
        onClose={() => setShowReceipt(false)}
        data={receiptData}
      />
    </S.Container>
  );
};

export default Wallet;
